import { WarningModal } from '@components/Modal'
import React, { useEffect, useState } from 'react'

interface IPFetchFail {
  error?: boolean
}

const FetchFail: React.FC<IPFetchFail> = ({ error = false }) => {
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    setModalOpen(error)
  }, [error])

  return <WarningModal open={modalOpen} onClose={() => setModalOpen(false)} anApiError noButtons />
}

export default FetchFail
